import { render } from "./HeroiconsSolidShoppingBag.vue?vue&type=template&id=276d894e"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShoppingBag.vue"]])

export default __exports__